<template>
    <button 
        class="btn btn-sm btn-outline-secondary"
        @click="toggleFullscreen"
        :title="isFullscreen ? 'Quitter le plein écran (Échap)' : 'Passer en plein écran (F11)'"
    >
        <i :class="isFullscreen ? 'fas fa-compress' : 'fas fa-expand'"></i>
        {{ isFullscreen ? 'Quitter' : 'Plein écran' }}
    </button>
</template>

<style scoped>
/* Aucun style nécessaire, tout est géré en JavaScript */
</style>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'FullscreenMapButton',
    
    props: {
        targetElement: {
            type: [Object, String],
            required: true
        }
    },

    data() {
        return {
            isFullscreen: false
        };
    },

    mounted() {
        // Écouter les changements de plein écran (quand l'utilisateur appuie sur Échap)
        document.addEventListener('fullscreenchange', this.onFullscreenChange);
        document.addEventListener('webkitfullscreenchange', this.onFullscreenChange);
        document.addEventListener('mozfullscreenchange', this.onFullscreenChange);
        document.addEventListener('MSFullscreenChange', this.onFullscreenChange);
    },

    beforeUnmount() {
        // Nettoyer les écouteurs d'événements
        document.removeEventListener('fullscreenchange', this.onFullscreenChange);
        document.removeEventListener('webkitfullscreenchange', this.onFullscreenChange);
        document.removeEventListener('mozfullscreenchange', this.onFullscreenChange);
        document.removeEventListener('MSFullscreenChange', this.onFullscreenChange);

        // Quitter le plein écran si actif
        if (this.isFullscreen) {
            this.exitFullscreen();
        }
    },

    methods: {
        toggleFullscreen() {
            if (this.isFullscreen) {
                this.exitFullscreen();
            } else {
                this.enterFullscreen();
            }
        },

        enterFullscreen() {
            const element = this.getTargetElement();
            
            if (!element) {
                console.error('Element not found for fullscreen');
                return;
            }

            // Différentes API selon le navigateur
            if (element.requestFullscreen) {
                element.requestFullscreen();
            } else if (element.webkitRequestFullscreen) { // Safari
                element.webkitRequestFullscreen();
            } else if (element.mozRequestFullScreen) { // Firefox
                element.mozRequestFullScreen();
            } else if (element.msRequestFullscreen) { // IE11
                element.msRequestFullscreen();
            }

            this.isFullscreen = true;
            this.$emit('fullscreen-changed', true);
            this.showToast('📺 Mode plein écran activé (Appuyez sur Échap pour quitter)');
        },

        exitFullscreen() {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.webkitExitFullscreen) { // Safari
                document.webkitExitFullscreen();
            } else if (document.mozCancelFullScreen) { // Firefox
                document.mozCancelFullScreen();
            } else if (document.msExitFullscreen) { // IE11
                document.msExitFullscreen();
            }

            this.isFullscreen = false;
            this.$emit('fullscreen-changed', false);
            this.showToast('📺 Mode plein écran désactivé');
        },

        onFullscreenChange() {
            // Mettre à jour l'état quand l'utilisateur quitte avec Échap
            const isCurrentlyFullscreen = !!(
                document.fullscreenElement ||
                document.webkitFullscreenElement ||
                document.mozFullScreenElement ||
                document.msFullscreenElement
            );

            if (this.isFullscreen !== isCurrentlyFullscreen) {
                this.isFullscreen = isCurrentlyFullscreen;
                this.$emit('fullscreen-changed', this.isFullscreen);
                
                if (!this.isFullscreen) {
                    this.showToast('📺 Mode plein écran désactivé');
                }
            }
        },

        getTargetElement() {
            if (typeof this.targetElement === 'string') {
                return document.getElementById(this.targetElement);
            }
            return this.targetElement;
        },

        showToast(message) {
            const toast = document.createElement('div');
            toast.textContent = message;
            toast.style.position = 'fixed';
            toast.style.bottom = '30px';
            toast.style.left = '50%';
            toast.style.transform = 'translateX(-50%)';
            toast.style.padding = '12px 18px';
            toast.style.background = 'linear-gradient(135deg, #673AB7, #512DA8)';
            toast.style.color = 'white';
            toast.style.borderRadius = '10px';
            toast.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
            toast.style.fontFamily = 'system-ui, sans-serif';
            toast.style.fontSize = '14px';
            toast.style.zIndex = '99999';
            toast.style.opacity = '0';
            toast.style.transition = 'opacity 0.3s ease';

            document.body.appendChild(toast);

            setTimeout(() => {
                toast.style.opacity = '1';
            }, 50);

            setTimeout(() => {
                toast.style.opacity = '0';
                setTimeout(() => toast.remove(), 300);
            }, 3000);
        }
    }
});
</script>